/**
 * Workaround to prevent Google Translate on Chrome browsers replacing
 * text nodes and causing an error that breaks our pages
 * Related: https://github.com/facebook/react/issues/11538
 */
export default function patchNodeRemoveChild() {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChild(child, ...args) {
    if (child.parentNode !== this) {
      // eslint-disable-next-line no-console
      console.warn('Failed to execute "removeChild" on "Node"');
      return child;
    }
    return originalRemoveChild.apply(this, [child, ...args]);
  };
}
